import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import CheckoutMiddleWare from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import PdpIrisMiddleware from './PdpIrisMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    AnalyticsMiddleware,
    MiniPDPAnalyticsMiddleware,
    CheckoutMiddleWare,
    PdpIrisMiddleware,
];

export default rootMiddleware;
